import { render, staticRenderFns } from "./RequirementsPage.vue?vue&type=template&id=e3f2eef8"
import script from "./RequirementsPage.vue?vue&type=script&lang=ts"
export * from "./RequirementsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3f2eef8')) {
      api.createRecord('e3f2eef8', component.options)
    } else {
      api.reload('e3f2eef8', component.options)
    }
    module.hot.accept("./RequirementsPage.vue?vue&type=template&id=e3f2eef8", function () {
      api.rerender('e3f2eef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/RequirementsPage.vue"
export default component.exports